module.exports = __webpack_public_path__ + "media/img/sda/ASC-sda-048f27ec7dfb77f1dbbd23787ed4b359.jpg";